module.exports = __webpack_public_path__ + "img/esrb-rating.50e98b76.svg";